import { render, staticRenderFns } from "./ViewArchivedNoteModal.vue?vue&type=template&id=afdb3c96"
import script from "./ViewArchivedNoteModal.vue?vue&type=script&lang=ts"
export * from "./ViewArchivedNoteModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports